






























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateCampaign from "./create.vue";
import EditCampaign from "./edit.vue";
import dayjs from "dayjs";

class PageCampaignRequest extends PageRequest {
  name: string = "";
  campaignCode: string = "";
  startTime: any;
  endTime: any;
}

@Component({
  components: { CreateCampaign, EditCampaign },
})
export default class CampaignsVM extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  pageRequest: PageCampaignRequest = new PageCampaignRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;

  downloadBook() {
    location.href = "BAy19SgIQx3u6V8/抽奖平台使用手册V2.pptx";
  }

  get list() {
    return this.$store.state.campaign.list;
  }

  get loading() {
    return this.$store.state.campaign.loading;
  }

  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("campaign/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("campaign/setPageSize", pagesize);
    this.getpage();
  }

  async getpage() {
    if (this.pageRequest.startTime) {
      this.pageRequest.startTime = dayjs(this.pageRequest.startTime).format(
        "YYYY-MM-DD"
      );
    }
    if (this.pageRequest.endTime) {
      this.pageRequest.endTime = dayjs(this.pageRequest.endTime).format(
        "YYYY-MM-DD 23:59:59"
      );
    }
    this.pageRequest.maxResultCount = this.pageSize;
    this.pageRequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "campaign/getAll",
      data: this.pageRequest,
    });
  }

  get pageSize() {
    return this.$store.state.campaign.pageSize;
  }

  get totalCount() {
    return this.$store.state.campaign.totalCount;
  }

  get currentPage() {
    return this.$store.state.campaign.currentPage;
  }

  columns = [
    {
      title: this.L("活动ID"),
      key: "id",
    },
    {
      title: this.L("活动名称"),
      key: "name",
    },
    {
      title: this.L("活动代码"),
      key: "campaignCode",
    },
    {
      title: this.L("开始时间"),
      key: "startTime",
    },
    {
      title: this.L("结束时间"),
      key: "endTime",
    },
    {
      title: this.L("活动状态"),
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.dataState == 1 ? this.L("启用") : this.L("禁用")
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("campaign/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("删除这个活动？"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "campaign/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];

  async created() {
    await this.getpage();
  }
}
